export enum DepartmentStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const DepartmentStatusOptions = [
  {
    label: "Active",
    value: DepartmentStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: DepartmentStatus.INACTIVE,
  },
];
